import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Stack,
    Collapse,
    Tooltip,
} from "@mui/material";
import { EyeIcon } from "../../icons";
import { fetchUniversityCourseWithSpecializationList } from "../../api/universityApi";

const ExpandRowTable = ({ row, col }) => {
    // State to track which course row is open
    const [openRow, setOpenRow] = useState(null);
    const [loading, setLoading] = useState(true)
    const [details, setDetails] = useState([])

    const handleToggle = (courseId) => {
        setOpenRow((prev) => (prev === courseId ? null : courseId));
    };

    const fetchUniversityDetails = () => {
        fetchUniversityCourseWithSpecializationList({ id: row?.id, setDetails, setLoading })
            .catch(err => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        if (row?.id) {
            fetchUniversityDetails()
        }
    }, [JSON.stringify(row)])

    console.log("row,col", details);


    return (
        <Box>
            <Paper sx={{ p: 1 }}>
                <Typography
                    variant="h6"
                    sx={{
                        mb: 2,
                        fontSize: "17px !important",
                        fontWeight: 600,
                        color: "#000",
                    }}
                >
                    🎓 Explore Courses & Specializations
                </Typography>

                <TableContainer component={Paper}>
                    <Table sx={{ width: '100%' }}>
                        <TableHead >
                            <TableRow sx={{ backgroundColor: "#f1f7ff", width: '100%', display: 'flex' }}>
                                <TableCell
                                    sx={{ fontWeight: 600, color: "#000", fontSize: "15px", width: '12%', borderBottom: 'none' }}
                                >
                                    Course
                                </TableCell>
                                <TableCell
                                    sx={{ fontWeight: 600, color: "#000", fontSize: "15px", width: '12%', borderBottom: 'none' }}
                                >
                                    Specializations
                                </TableCell>

                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {loading ? "loading..." : details?.courses?.map((course, index) => (
                                <React.Fragment key={course?._id}>
                                    <TableRow
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            backgroundColor:
                                                index % 2 === 0 ? "#ffffff" : "#f1f7ff",
                                            // "&:hover": {
                                            //     backgroundColor: "#f1f7ff",
                                            // },
                                        }}
                                    >
                                        {/* Course Name */}
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                color: "#000",
                                                fontSize: "15px",
                                                width: '12%',
                                                borderBottom: 'none'
                                            }}
                                        >
                                            {course?.courseName}
                                        </TableCell>

                                        {/* Specializations (click to expand) */}
                                        <TableCell
                                            sx={{
                                                width: '12%',
                                                borderBottom: 'none'
                                            }}>
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                                <Box
                                                    className="exploresecopen"
                                                    sx={{
                                                        backgroundColor: "#ececec",
                                                        color: "#000",
                                                        fontWeight: 400,
                                                        padding: "6px 12px",
                                                        borderRadius: "40px",
                                                        cursor: "pointer",
                                                    }}

                                                >
                                                    {course?.specializations?.length}
                                                </Box>
                                                <Box>
                                                    <Tooltip title="View Specialization List" arrow>
                                                        <Box
                                                            sx={{
                                                                height: "100%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => handleToggle(course._id)} expand
                                                        >
                                                            <EyeIcon sx={{ color: "#363853", fontSize: "20px" }} />
                                                        </Box>
                                                    </Tooltip>
                                                </Box>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>

                                    {/* Expanded Section */}
                                    <TableRow
                                        className="thisecpand"
                                        sx={{ background: "#fafafa", display: 'flex' }}
                                    >
                                        <TableCell
                                            colSpan={12}
                                            sx={{ paddingBottom: 0, paddingTop: 0, width: '22%', borderBottom: 'none' }}
                                        >
                                            <Collapse
                                                in={openRow === course?._id}
                                                timeout="auto"
                                                unmountOnExit
                                            >
                                                <Box sx={{
                                                    py: 2,
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap'
                                                }}>
                                                    {course?.specializations?.map((spec, i) => (
                                                        <Box
                                                            key={i}
                                                            className="exploresecopen"
                                                            sx={{
                                                                color: "#000",
                                                                fontWeight: 400,
                                                                cursor: "pointer",
                                                                marginBottom: '10px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '10px',
                                                                width: '33%',

                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    background: '#0463ef',
                                                                    color: '#fff',
                                                                    width: '7px',
                                                                    height: '7px',
                                                                    borderRadius: '40px',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                }}
                                                            ></span> <span style={{textWrap: 'auto'}}>{spec?.specializationName}</span>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default ExpandRowTable;